import axios from 'axios'
import {
  timeOutRequest,
  baseURL,
  version,
  VERSION_2,
  VERSION_3,
  VERSION_4,
  VERSION_5,
} from './config'
import i18n from '../i18n'
import STORAGE_KEYS from '../constants/localStorage'
import { store } from '~/redux/store'
import { EXTERNAL_PARTNER, MERCHANT_TYPE } from '~/constants/restaurant'

export default function request() {
  const { restaurantSlug, tableUid, merchant_type, food_court_slug, externalPartner } =
    store.getState().restaurant.data

  // Header kèm token: phục vụ cho việc yêu cầu user scan lại QR sau khi thanh toán
  const tokenHeader = {
    'Serving-Token': localStorage.getItem(STORAGE_KEYS.servingToken) || '',
  }

  if (restaurantSlug) tokenHeader['Restaurant-Slug'] = restaurantSlug

  const userName = localStorage.getItem(STORAGE_KEYS.USER_NAME)
  if (userName) tokenHeader['User-Name'] = encodeURIComponent(userName)

  if (tableUid) tokenHeader['Serving-Table-UUID'] = tableUid // Nếu có serving table uuid mới gửi lên

  const servingSessionID = localStorage.getItem(STORAGE_KEYS.SERVING_SESSION_ID)
  if (servingSessionID) tokenHeader['Serving-Session-ID'] = servingSessionID // Nếu có serving session id thì mới gửi lên

  let versionUpdated = version
  // Nếu trong trường hợp là hotel sẽ call api v2. Vì chưa có table uuid nên gọi v1 sẽ lỗi
  if (merchant_type === MERCHANT_TYPE.HOTEL) versionUpdated = VERSION_2

  // Nếu trong trường hợp là food court sẽ chuyển qua version 3 và gửi lên food court slug ở header
  if (food_court_slug) {
    versionUpdated = VERSION_3
    tokenHeader['Food-Court-Slug'] = food_court_slug
  }
  // Trong trường hợp là souvenir -> lên v4
  if (merchant_type === MERCHANT_TYPE.SOUVENIR) versionUpdated = VERSION_4

  // Trong trường hợp là external partner là sukiya -> lên v5
  if (externalPartner === EXTERNAL_PARTNER.Sukiya) versionUpdated = VERSION_5

  const defaultOptions = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Accept-Language': i18n.language || localStorage.getItem(STORAGE_KEYS.LOCALE),
      ...tokenHeader,
    },
    baseURL: `${baseURL}${versionUpdated}/customers`,
    timeout: timeOutRequest,
  }

  return {
    get: (url, options = {}) => axios.get(url, { ...defaultOptions, ...options }),
    post: (url, data, options = {}) => {
      return axios.post(url, data, { ...defaultOptions, ...options })
    },
    put: (url, data, options = {}) => axios.put(url, data, { ...defaultOptions, ...options }),
    delete: (url, options = {}) => axios.delete(url, { ...defaultOptions, ...options }),
  }
}
